import cn from "classnames"

import { Img } from "ui-kit/components-branded/index"
import { BrowserWarningType } from "components/BrowserWarningBanner/BrowserWarningType"
import { isVideoCallsUnsupported } from "utils/isVideoCallsUnsupported"

export function BrowserWarningBanner(props: { type: BrowserWarningType; className?: string }) {
    if (!isVideoCallsUnsupported) return null

    return (
        <div
            className={cn(
                "browser-warning-banner__wrapper",
                {
                    "browser-warning-banner__lite":
                        props.type === BrowserWarningType.Session ||
                        props.type === BrowserWarningType.UpcommingSession,
                    "browser-warning-banner__dark":
                        props.type === BrowserWarningType.SessionStarted ||
                        props.type === BrowserWarningType.SessionStartedWide,
                },
                props.className
            )}
        >
            {props.type === BrowserWarningType.Session && (
                <div className="browser-warning-banner__header">
                    Сессия пройдет на&nbsp;платформе Alter
                </div>
            )}
            {props.type === BrowserWarningType.UpcommingSession && (
                <div className="browser-warning-banner__header">
                    Ваша ближайшая сессия пройдет на&nbsp;платформе Alter
                </div>
            )}
            <div>
                <div
                    className={cn({
                        "browser-warning-banner__inline":
                            props.type === BrowserWarningType.SessionStartedWide,
                    })}
                >
                    Для&nbsp;стабильной видеосвязи используйте браузеры{" "}
                    <a
                        className="browser-warning-banner__link"
                        href="https://www.google.com/chrome/"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >
                        Google&nbsp;Chrome
                    </a>{" "}
                    или&nbsp;
                    <a
                        className="browser-warning-banner__link"
                        href="https://www.mozilla.org/firefox/new/"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >
                        Firefox
                    </a>
                    .
                </div>
                <div
                    className={cn({
                        "browser-warning-banner__inline":
                            props.type === BrowserWarningType.SessionStartedWide,
                    })}
                >
                    <Img src="attention.png" className="browser-warning-banner__warning" />
                    В&nbsp;Safari ниже 15&nbsp;версии видеосвязь может не&nbsp;работать.&nbsp;
                    {(props.type === BrowserWarningType.Session ||
                        props.type === BrowserWarningType.UpcommingSession) && (
                        <>Скачайте браузер заранее.</>
                    )}
                </div>
            </div>
        </div>
    )
}

export * from "components/BrowserWarningBanner/BrowserWarningType"
